import axios from "axios";

export const saveDataExpociencias22 = async(props) => {
    const url = process.env.REACT_APP_BASE_URL + "/api/expociencias22";

    const values = {...props}
    console.log(values);

    var result = [];

    await axios.post(url, values)
    .then( response => {
        const data = response.data;
        result = {...data};
        if (data.exito === 1) {
            console.log("datos guardados...");
        }
    })

    return result;
};
